import { Button } from "@mui/material";
import { forwardRef } from "react";
import Icon from "../Icon/Icon";

const FilterButton = forwardRef(({ label, selected, onClick, className, size, ...props }, ref) => (
    <Button
        ref={ref}
        size={size}
        variant="stateful"
        className={`${selected ? 'active' : ''} ${className ?? ''}`.trim()}
        startIcon={selected ? <Icon icon="fa-check" /> : null}
        onClick={onClick}
        {...props}
    >
        {label}
    </Button>
));

export default FilterButton;